import Avatar1 from "@/assets/images/HeroStats/Avatar1.png";
import Avatar2 from "@/assets/images/HeroStats/Avatar2.png";
import Avatar3 from "@/assets/images/HeroStats/Avatar3.png";
import CtaButtonGroup, { CtaType } from '@/components/molecules/CtaButtonGroup';
import Image from "next/image";
import React from 'react';

interface AboutCreatorProps {
  subTitle:string;
  title:string;
  highlightedTitle:string;
  benefits: string[];
  gradient: boolean;
  ctas: CtaType[];
}

const CreatorResult: React.FC<AboutCreatorProps> = ({ gradient, subTitle, ctas, title, highlightedTitle }) => {

  const creatorImages = [
    {
      src: Avatar1,
      alt: "avatar1",
    },
    {
      src: Avatar2,
      alt: "avatar2",
    },
    {
      src: Avatar3,
      alt: "avatar3",
    },
  ];
    
  return (
    <div className={`relative w-full overflow-hidden text-center ${
        gradient ? "bg-aurora1" : "bg-purple-0"
      } py-6 sm:py-12`}>
      <div className="max-w-4xl mx-auto flex flex-col items-center">
      <div className="flex items-center justify-center">
        <Image src="/images/creator-results.png" alt="src" width={200} height={200}/>
        {/* {creatorImages.map((avatar, index) => (
          <div
            key={index}
            className="-ml-9 rounded-full border-4 border-paleYellow"
          >
            <Image height={100} width={100} src={avatar.src} alt={avatar.alt} />
          </div>
        ))} */}
      </div>
      <h2 className="text-3xl font-bold mb-4 mt-6">
        {title}
      </h2>
      <p className="text-4xl font-bold text-purple-3 mb-8">
        {highlightedTitle}
      </p>
      <div className="mt-12 text-center">
        <p className="mb-4">{subTitle}</p>
        <CtaButtonGroup align="sm:center" ctas={ctas} affiliateButton={true} />
      </div>
    </div>
    </div>
  );
};

export default CreatorResult;